module.exports = __webpack_public_path__ + "img/logo_60.c15a33c2.svg";